import type { ContentObject } from 'models';

/**
 * @deprecated This only exists because of the JS-to-TSX port; don't take it as inspiration for new
 * code. The single id used everywhere a content object needs to be matched or cached by: feed/list
 * items and detail pages are both keyed by this id, never by the content object's own top-level `id`.
 */
export const getContentObjectId = (contentObject: ContentObject): string => {
  switch (contentObject.type) {
    case 'activity':
      return contentObject.activity.id;
    case 'comment':
      return contentObject.comment.id;
    case 'event':
      return ('nodeId' in contentObject.event ? contentObject.event.nodeId : undefined) ?? contentObject.event.id;
    case 'giving':
      return contentObject.giving.id;
    case 'kudo':
      return contentObject.kudo.id;
    case 'poll':
      return contentObject.poll.id;
    case 'post':
      return contentObject.post.id;
    case 'video':
      return contentObject.video.id;
    case 'withings_order_post':
      return contentObject.withings_order_post.id;
    default:
      return (contentObject as { id: string }).id;
  }
};

/**
 * @deprecated This only exists because of the JS-to-TSX port; don't take it as inspiration for new
 * code. A malformed/unexpected item already in the cache must never take down a whole batch update
 * for every other item, so id resolution used while scanning a list of cached items never throws.
 */
export const getContentObjectIdSafe = (contentObject: ContentObject) => {
  try {
    return getContentObjectId(contentObject);
  } catch {
    return undefined;
  }
};
